"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @deprecated use Link from foundation/Link
 * @optimized using svgo:^3.0.2
 */
export const Link = createSVGIcon(
  <path
    d="M1.52 8A2.48 2.48 0 0 1 4 5.52h2.44a.76.76 0 1 0 0-1.52H4C1.792 4 0 5.792 0 8s1.792 4 4 4h2.44a.76.76 0 0 0 0-1.52H4A2.48 2.48 0 0 1 1.52 8M4.8 8a.8.8 0 0 0 .8.8h4.8a.8.8 0 0 0 0-1.6H5.6a.8.8 0 0 0-.8.8M12 4H9.56a.76.76 0 1 0 0 1.52H12A2.48 2.48 0 0 1 14.48 8 2.48 2.48 0 0 1 12 10.48H9.56a.76.76 0 0 0 0 1.52H12c2.208 0 4-1.792 4-4s-1.792-4-4-4"
    fill="currentColor"
  />,
  "LinkIcon",
  { viewBox: "0 0 16 16", fill: "none" }
);
